import { render, staticRenderFns } from "./_base-side-bar.vue?vue&type=template&id=67c3b358&scoped=true&"
import script from "./_base-side-bar.vue?vue&type=script&lang=js&"
export * from "./_base-side-bar.vue?vue&type=script&lang=js&"
import style0 from "./_base-side-bar.vue?vue&type=style&index=0&id=67c3b358&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c3b358",
  null
  
)

export default component.exports